import { NotifyErrorWrapper, NotifySuccess } from '@/helpers/core/notifications'
import {
  createPremiumInvoice,
  deletePremiumInvoice,
  getPremiumInvoices,
  updatePremiumInvoice,
} from '@/services/asicw/premium-invoices.service'
import type { IPremiumInvoiceFilters, IUpdateInvoiceForm } from '@/types/asicw/invoices'

import { useMutation, useQuery, useQueryClient } from '@tanstack/vue-query'

export const usePremiumInvoices = () => {
  const queryClient = useQueryClient()

  const getPremiumInvoicesQuery = (filters: IPremiumInvoiceFilters) =>
    useQuery({
      queryKey: ['premium-invoices', filters],
      queryFn: () => getPremiumInvoices(filters),
      placeholderData: (prev: any) => prev,
    })

  const deletePremiumInvoiceMutation = useMutation({
    mutationFn: (invoiceId: number) => {
      return deletePremiumInvoice(invoiceId)
    },
    onSuccess: () => {
      NotifySuccess(`Invoice deleted successfully.`)
      queryClient.invalidateQueries({ queryKey: ['premium-invoices'] })
    },
    onError: NotifyErrorWrapper('Failed to delete invoice'),
  })

  const updatePremiumInvoiceMutation = useMutation({
    mutationFn: ({ id, data }: { id: number; data: IUpdateInvoiceForm }) => updatePremiumInvoice(id, data),
    onSuccess: () => {
      NotifySuccess('Invoice updated successfully.')
      queryClient.invalidateQueries({ queryKey: ['premium-invoices'] })
    },
    onError: NotifyErrorWrapper('Failed to update invoice'),
  })

  const createPremiumInvoiceMutation = useMutation({
    mutationFn: createPremiumInvoice,
    onSuccess: () => {
      NotifySuccess(`Invoice created successfully.`)
      queryClient.invalidateQueries({ queryKey: ['premium-invoices'] })
    },
    onError: NotifyErrorWrapper('Failed to create invoice'),
  })

  return {
    getPremiumInvoicesQuery,
    deletePremiumInvoiceMutation,
    updatePremiumInvoiceMutation,
    createPremiumInvoiceMutation,
  }
}
